import { ReducerCreators } from '@reduxjs/toolkit';
import { AudiencesState } from '../types';
import { AttendeeSortDirection } from '@/types/all-attendees.types';

type SortPayload = {
  sort: string;
  sortDirection: AttendeeSortDirection;
};

export const setListAttendeesSort = (create: ReducerCreators<AudiencesState>) =>
  create.reducer<SortPayload>((state, action) => {
    state.listAttendees.sort = action.payload.sort;
    state.listAttendees.sortDirection = action.payload.sortDirection;
    state.listAttendees.page = 1;
  });
